<template>
  <div class="mb-4">
    <h3>Yêu cầu cấp lại mật khẩu mới</h3>
  </div>

  <form autocomplete="off" onsubmit="event.preventDefault();">
    <div v-if="!forgetPasswordForm.attempt_token">
      <div>
        <label>Email</label>
        <input class="form-control" type="text" placeholder="Email đăng nhập" v-model="forgetPasswordForm.email"
          :class="{ 'border-danger': errors.email }">
        <div class="msg-error" v-if="errors.email">{{ errors.email[0] }}</div>
      </div>

      <div class="mt-4">
        <button class="btn btn-success" style="width: 100%" @click="onNextStepForgetPassword()">
          <div v-if="isLoading" class="spinner-border spinner-border-sm" role="status">
            <span class="sr-only"></span>
          </div> Kiểm tra
        </button>
      </div>
    </div>
    <div v-else>
      <div class="alert alert-info">Nhập mã trong ứng dụng 2-FA</div>
      <div>
        <label>Mã 2-Fa</label>
        <input class="form-control" type="text" placeholder="Verify code" v-model="forgetPasswordForm.code"
          :class="{ 'border-danger': errors.code }">
        <div class="msg-error" v-if="errors.code">{{ errors.code[0] }}</div>
      </div>

      <div class="mt-3">
        <label>Mật khẩu mới</label>
        <input class="form-control" type="password" placeholder="Mật khẩu mới" v-model="forgetPasswordForm.password"
          :class="{ 'border-danger': errors.password }">
        <div class="msg-error" v-if="errors.password">{{ errors.password[0] }}
        </div>
      </div>

      <div class="mt-3">
        <label>Mật khẩu xác nhận</label>
        <input class="form-control" type="password" placeholder="Mật khẩu xác nhận"
          v-model="forgetPasswordForm.confirm_password" :class="{ 'border-danger': errors.confirm_password }">
        <div class="msg-error" v-if="errors.confirm_password">{{
          errors.confirm_password[0] }}</div>
      </div>

      <div class="mt-4">
        <button class="btn btn-success" style="width: 100%" @click="onNextStepForgetPassword()">
          <div v-if="isLoading" class="spinner-border spinner-border-sm" role="status">
            <span class="sr-only"></span>
          </div> Đổi mật khẩu
        </button>
      </div>
    </div>
  </form>

  <div class="mt-4">
    <a href="javascript: void(0)" @click="$emit('return', 'signin')"><i class="fa-solid fa-arrow-left-long"></i> Quay lại trang đăng nhập</a>
  </div>
</template>

<style lang="scss" scoped>
label {
  font-size: 0.8rem;
  margin-bottom: 2px;
}

h3{
  font-size: 1.2rem;
  text-align: center;
}

.line {
  &:hover {
    background-color: var(--color-page-menu-bg-hover);
    cursor: pointer;
  }

  &:not(:last-child) {
    border-bottom: 1px solid var(--color-top-menu-border);
  }

  >div {
    display: flex;
    align-items: center;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;

    &:last-child {
      justify-content: end;
    }

    &:first-child {
      i {
        margin-right: 5px;
      }
    }

    >button {
      color: var(--color-body-text);
      font-size: 1.3rem;
      border: 0 !important;

      &:focus,
      &:active {
        outline: 0;
        border: 0 !important;
      }
    }
  }
}
</style>

<script>
export default {
  data() {
    return {
      isLoading: false,
      errors: {},
      methods: {},
      forgetPasswordForm: {
        email: '',
        code: '',
        attempt_token: '',
        password: '',
        confirm_password: ''
      }
    }
  },

  methods: {
    async onNextStepForgetPassword() {
      this.isLoading = true;
      this.errors = {};

      // Step 1
      if (!this.forgetPasswordForm.attempt_token) {
        let res = await this.$api.password.attempt({
          email: this.forgetPasswordForm.email
        }).call();

        if (res.success) {
          if (res.response.result.next == 'contact') {
            this.$store.dispatch("confirmation/open", {
              title: "Thông báo",
              type: 'info',
              message: "Tài khoản của bạn chưa xác thực 2-FA, vui lòng liên hệ Admin để cung cấp lại mật khẩu.",
              options: [
                {
                  name: "ok",
                  label: "OK",
                  variant: "primary"
                },
              ]
            });
          } else {
            this.forgetPasswordForm.attempt_token = res.response.result.attempt_token;
          }
        } else {
          this.errors = res?.response?.result?.errors || {};
        }
      } else {
        let res = await this.$api.password.reset({
          email: this.forgetPasswordForm.email,
          attempt_token: this.forgetPasswordForm.attempt_token,
          code: this.forgetPasswordForm.code,
          password: this.forgetPasswordForm.password,
          confirm_password: this.forgetPasswordForm.confirm_password
        }).call();

        if (res.success) {
          this.$store.dispatch('toast/show', {
            data: { message: 'Change password successfully' },
            variant: 'success',
            delay: 2000
          });
          this.$emit('return', 'signin');
        } else {
          this.errors = res?.response?.result?.errors || {};
        }
      }

      this.isLoading = false;
    }
  }
}
</script>